<template>
  <div>
    <div class="hidden-container">
      <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
        <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
      </form>
    </div>
    <div v-if="showButtons" class="row page-heading">
      <div class="col-7 input module_heading">
        <div class="module_icon fas fa-address-book"></div>
        <label class="head_txt module_type_name">{{career.name}}</label>
        <b-input-group>
          <button class="btn-cancel" @click="cancelClicked"><span class="icon-cross" aria-label="close"></span></button>
          <button :class="{disabled: !careerDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="submitted" aria-label="done">done</button>
          <button :class="{disabled: !careerDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(false)" aria-label="save">save</button>
        </b-input-group>
      </div>
      <div class="col-5 float-right px-0">

      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="col-3">
          <div v-if="showButtons" class="thumbnail_container d-flex">
            <img v-if="thumbnailURI" id="careerThumbnail" :src="thumbnailURI">
            <b-btn @click="addThumbnailClicked">edit thumbnail</b-btn>
          </div>
          <div v-if="showIsLoadingMessage">
            <span>
              Loading... Please wait...
            </span>
          </div>

          <b-modal ref="modal" id="addCareerThumbnailPopup"
                    v-model="showAddThumbnailModal"
                    ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered
                    class="modal_popup popup_add_thumbnail">

					  <div slot="modal-header" class="popover-header">
						<div class="popup-heading">Update Thumbnail</div>
							<button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
								<span class="ic-close"></span>
							</button>
						</div>

                    <div class="row">

	        			<div class="col-4">
	           				<div class="thumbnail_msg">How your thumbnail will appear</div>
	           				<div class="thumbnail_container">
                      <b-btn v-if="thumbnailURI && thumbnailURI.length > 0" @click.stop="removeThumbnailClicked" class="btn">remove thumbnail</b-btn>
	           					<img v-if="thumbnailURI" id="careerThumbnail" :src="thumbnailURI">
	           					<span v-else class="ic fas fa-address-book"></span>
	           				</div>
	        			</div>

	        			<div class="col-7 right-model-box">

	        			<div class="row fld_row">
           					<div class="col-1 fld_col_label">
          						<label>URL</label>
          					</div>
          					<div class="col-8 fld_col_input">
           						<input :disabled="!isEditingThumbnail" v-model="thumbnailURI" placeholder="http://"></input>
           					</div>
           					<div class="col-3 btn_container">
           					</div>
           				</div>

           				<div class="row fld_row msg_row">
           					<div class="col-1"></div>
           					<div class="col-11 msg">Add image url for thumbnail.</div>
            			</div>

            			<div class="row txt_sep_row">
            				<div class="col-12">OR</div>
            			</div>

            			<div class="row fld_row">
            				<div class="col-1 fld_col_label">
            					<label>File</label>
            				</div>
            				<div class="col-8 fld_col_input">
            					<input disabled v-model="thumbnail" placeholder="choose a file from your computer"></input>
            				</div>
           					<div class="col-3 fld_col_btn">
            					<b-btn :disabled="!isEditingThumbnail" @click.stop="chooseFile()">add file</b-btn>
            				</div>
            			</div>

            			<div class="row msg_row">
           					<div class="col-1"></div>
           					<div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
            			</div>

	        			</div>

					</div>

            		<div slot="modal-footer">
              			<b-btn @click="addNewThumbnail">save and next</b-btn>
              			<b-btn @click="cancelAddThumbnail">cancel</b-btn>
            		</div>

          		</b-modal>
        	</div>

      </div>
    </div>
  </div>
</template>

<script>
  /* global AWS:true */
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import { AwsObject } from '../aws'

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    console.log('creating file: ', file)
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
    // added
    // this.uri = file.uri
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'edit-career',
    props: ['code', 'loadDataFromServer'],
    components: {
    },
    data: () => {
      return {
        userId: {},
        thumbnailURI: '',
        thumbnail: '',
        thumbnailURICopy: '',
        thumbnailCopy: '',
        showAddThumbnailModal: false,
        fileUploadArray: [],
        errors: [],
        owningLibrary: {},
        isEditingThumbnail: false,
        showButtons: false,
        showIsLoadingMessage: false
      }
    },
    created () {
      window.addEventListener('unload', this.goToDetail)
    },
    mounted () {
      // TODO detect page refresh and route back to detail
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public') {
              this.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
            }
          }
        }
        if (this.folders.length > 0 && _.isEmpty(this.owningLibrary)) {
          this.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
        }
      })
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
      this.loadDataForCareerDetail()
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'storeCareer',
        'loadLibrariesForUser',
        'uploadContentAndGetUri',
        'updateFileUriAndVersionIdAfterS3Upload',
        'loadCurrentEnvironment'
      ]),
      goToDetail () {
        this.$router.push({ name: 'careerDetail', params: { code: this.code } })
      },
      loadDataForCareerDetail () {
        this.loadCareer({ code: this.code, loadDataFromServer: this.loadDataFromServer }).then(response => {
          this.uuid = response.uuid.slice(0)
          this.thumbnailURI = (response.thumbnailURI) ? response.thumbnailURI.slice(0) : ''
          this.thumbnail = (response.thumbnailURI) ? response.thumbnailURI.slice(0) : ''
        })
        this.addThumbnailClicked()
      },
      careerDataIsValid () {
        if (this.uuid) {
          return true
        }
        return false
      },
      onSubmit (isDone) {
        if (!this.careerDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        this.submitted = true

        const careerData = {
          uuid: this.uuid,
          thumbnailURI: this.thumbnailURI
        }
        this.storeCareer(careerData).then(response => {
          if (isDone) {
            return this.$router.push({ name: 'careerList' })
          } else {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Career "' + this.career.name + ' updated successfully.'
            })
            this.submitted = false
          }
        })
      },
      addThumbnailClicked () {
        this.showAddThumbnailModal = true
        this.isEditingThumbnail = true
        this.thumbnailURICopy = this.thumbnailURI.slice(0)
        this.thumbnailCopy = this.thumbnail.slice(0)
      },
      removeThumbnailClicked () {
        this.isEditingThumbnail = true
        this.thumbnailURI = ''
        this.thumbnail = ''
      },
      cancelAddThumbnail () {
        this.thumbnailURI = this.thumbnailURICopy
        this.thumbnail = this.thumbnailCopy
        this.isEditingThumbnail = false
        this.showAddThumbnailModal = false
        this.errors = []
        this.fileUploadArray = []
        this.$router.push({ name: 'careerList' })
      },
      addNewThumbnail () {
        if (this.thumbnail !== this.thumbnailURI) {
          // user entered url instead of uploading local file, no upload necessary
          this.thumbnail = this.thumbnailURI
        } else {
          this.uploadFiles()
        }
        this.showAddThumbnailModal = false
        this.isEditingThumbnail = false
        this.saveAndRedirectToListPage()
      },
      saveAndRedirectToListPage () {
        let isDone = true
        this.onSubmit(isDone)
      },
      chooseFile () {
        $('input[type=file][id=thumbnailFileList]').click()
      },
      thumbnailToBeUploaded (ev) {
        this.fileUploadArray = []
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length || files.length <= 0) {
          return
        }
        this.thumbnailURI = files[0].name
        this.thumbnail = files[0].name
        this.prepareFileUploadArray(files)
      },
      prepareFileUploadArray (files) {
        if (files) {
          console.log('files: ', files)
          var timestamp = new Date().getTime()
          for (var i = 0; i < files.length; i++) {
            timestamp = timestamp + i
            this.addFileToUploadArray(files[i], timestamp)
          }
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        var isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
        console.log('new fileUploadArray: ', this.fileUploadArray)
      },
      uploadFiles () {
        let fileUploadArrayClone = clone(this.fileUploadArray)
        let contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          let content = fileUploadArrayClone[i]
          console.log('creating content item: ', content)
          let item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'thumbnail': content.thumbnail,
            'thumbnailURI': content.thumbnailURI
          }
          contentListToCreate.push(item)
        }
        if (contentListToCreate.length <= 0) {
          return
        }
        this.uploadContentAndGetUri({
          learningSpaceId: this.owningLibrary.uuid,
          contents: contentListToCreate,
          success: this.uploadFileAfterCreateContentSuccessCallback,
          failure: this.uploadFileAfterCreateContentErrorCallback
        })
      },
      cancelClicked () {
        return this.$router.push({ name: 'careerDetail', params: { code: this.code } })
      },
      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.fileUploadArray = []
        this.showSuccessPopup()
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        }
      },
      storeFilesToS3 (filesToBeUploaded) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
            } else {
              var uri = item.uri
              if (uri.indexOf('?versionId=') === -1) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
            }
            let thumbnailData = filesToBeUploaded[0]
            this.thumbnailURI = thumbnailData.uri
            this.thumbnail = thumbnailData.uri
            this.saveAndRedirectToListPage()
          })
        })
      },
      showSuccessPopup () {
        console.log('file upload successful!')
      }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject,
        'learningSpaces': state => state.assessment.learningSpaces,
        'ownerId': state => state.career.careerObject.ownerId,
        'owningLibraryId': state => state.career.careerObject.owningLibraryId,
        'currentEnvironment': state => state.learningContent.currentEnvironment
      })
    },
    watch: {

    }
  }
</script>

<style scoped>
.input-group {
  z-index: 2;
}

.hidden-container {
  visibility: hidden;
  height: 1px;
}

.heading {
  font-size: 20px;
}

.tag-container {
	max-height: fit-content !important;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/app/career/components/EditCareer.vue